import {
  FieldValues,
  SubmitHandler,
  useForm,
  FormProvider,
} from "react-hook-form";

interface FormProps {
  defaultValues?: { [key: string]: string };
  children: React.ReactElement | React.ReactElement[];
  onSubmit?: SubmitHandler<FieldValues>;
}

const Form = ({
  defaultValues,
  children,
  onSubmit = () => null,
}: FormProps): JSX.Element => {
  const methods = useForm({ defaultValues });

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>{children}</form>
    </FormProvider>
  );
};

export { Form };
